"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDetailEntity = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const AppDetailDto_1 = require("./AppDetailDto");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class AppDetailEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, appDetail) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            appStoreId: false,
            icon: false,
            totalDownloads: false,
            totalUpdates: false
        };
        this._dependencies = dependencies;
        if (appDetail === undefined) {
            this._dto = new AppDetailDto_1.AppDetailDto();
        }
        else if (appDetail instanceof AppDetailDto_1.AppDetailDto) {
            this._dto = new AppDetailDto_1.AppDetailDto(appDetail);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (appDetail instanceof AppDetailEntity) {
            this._dto = new AppDetailDto_1.AppDetailDto(appDetail._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AppDetailDto_1.AppDetailDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    getAppId() {
        return this._dto.appId;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getAppStoreId() {
        return this._dto.appStoreId;
    }
    setAppStoreId(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("appStoreId");
        this._requiredFieldsSetStatus.appStoreId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("appStoreId", "App Store Id is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("appStoreId", `App Store Id has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.appStoreId) {
            return;
        }
        this._dto.appStoreId = _untrustedValue;
        this._setIsDirty(true);
    }
    getIcon() {
        return this._dto.icon;
    }
    setIcon(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("icon");
        this._requiredFieldsSetStatus.icon = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("icon", "Icon is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("icon", `Icon has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.icon) {
            return;
        }
        this._dto.icon = _untrustedValue;
        this._setIsDirty(true);
    }
    getTotalDownloads() {
        return this._dto.totalDownloads;
    }
    setTotalDownloads(untrustedValue) {
        let _untrustedValue;
        this.clearError("totalDownloads");
        this._requiredFieldsSetStatus.totalDownloads = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("totalDownloads", "Total Downloads is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("totalDownloads", "Total Downloads is required."));
        }
        else if (_untrustedValue <= 0) {
            this.addError(new ValidationError_1.ValidationError("totalDownloads", "Total Downloads must be greater than 0."));
        }
        if (!this.isNew && _untrustedValue === this._dto.totalDownloads) {
            return;
        }
        this._dto.totalDownloads = _untrustedValue;
        this._setIsDirty(true);
    }
    getTotalUpdates() {
        return this._dto.totalUpdates;
    }
    setTotalUpdates(untrustedValue) {
        let _untrustedValue;
        this.clearError("totalUpdates");
        this._requiredFieldsSetStatus.totalUpdates = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("totalUpdates", "Total Updates is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("totalUpdates", "Total Updates is required."));
        }
        else if (_untrustedValue <= 0) {
            this.addError(new ValidationError_1.ValidationError("totalUpdates", "Total Updates must be greater than 0."));
        }
        if (!this.isNew && _untrustedValue === this._dto.totalUpdates) {
            return;
        }
        this._dto.totalUpdates = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.appDetailDatastore
                    .getAsync(id, expand);
                delete this._appEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("App Detail is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.appDetailDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.appDetailDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("App Detail cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.appDetailDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AppDetailEntity = AppDetailEntity;
//# sourceMappingURL=AppDetailEntity.js.map